<template>
  <ul
    v-if="list.length>0"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="moreLoading"
    infinite-scroll-distance="100"
    infinite-scroll-immediate-check="false">
    <li class="comments" v-for="(item,i) in list" :key="'A'+i" @click="$router.push('/supply/details/'+item)">
      <!-- 用户信息 -->
      <div class="comUser">
        <div class="userImg">
          <img v-lazy="item.img_url" alt="" />
        </div>
        <div class="userInfo"> 
          <h6>
            {{item.name}}
            <span>{{item.duties}}</span>
            <span v-if="true" class="approve">认证展商</span>
          </h6>
          <p>{{item.corpname}}</p>
        </div>
      </div>
      <!-- 简介 -->
      <p class="comIntro">
        {{item.content}}
      </p>
      <!-- 定位 -->
      <div class="place" v-if="false">
        <i class="iconfont icon-dingwei"></i><span>北京通州</span>
      </div>
      <!-- 商品图片 -->
      <div class="goodsImg" v-if="item.content_img">
        <div v-for="(imgitem,i) in item.content_img" :key="'img'+i">
          <img v-lazy="imgitem.img_url" :alt="imgitem.img_info_cn"/>
        </div>
      </div>
      <!-- footer -->
      <div class="comAction">
        <span class="time">
          {{item.ctime}}
        </span>
        <div class="action">
          <span>
            <i class="iconfont icon-iconfontzhizuobiaozhun0258"></i>
            联系
          </span>
          <span>
            <i class="iconfont icon-liuyan"></i>
            {{item.comment}}
          </span>
          <span>
            <i class="iconfont icon-yanjing"></i>
            {{item.click}}
          </span>
        </div>
      </div>
    </li>
    <li class="more_loading" >
      <span v-show="list.length<listnum">
        <div class="m_upload">
          <mt-spinner type="snake" color="#00ccff" :size="20" ></mt-spinner>
          <span>加载中</span>
        </div>
      </span>
      <span v-show="list.length>=listnum" class="over">我是有底线的！！！</span>
    </li>
  </ul>
  <div v-else class="zanwu">
    <div><img v-lazy="hrefurl+'/public/icon/without.png'" alt="" /></div>
    <p class="p">暂无信息可查看，快来发布信息发布吧！</p>
  </div>
</template>

<script>
import Vue from "vue"
import { TabContainer, TabContainerItem, InfiniteScroll, Spinner } from 'mint-ui';
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.component(Spinner.name, Spinner);
Vue.use(InfiniteScroll);
export default {
  props:{
    list:Array,//请求数据列表
    listnum:Number,//总条数
  },
  data () {
    return {
      
    }
  },
  methods:{
    // 分页上划加载
    loadMore(){
      // 全部加载完毕
      if (this.list.length>=this.listnum) {
        return
      }
      // 发请求数据标志数据
      this.$emit("loading")
    }
  }

}
</script>

<style scoped>
  


  .comments{
    width: 100%;
    padding: 10px;
    margin-bottom: 15px;
    overflow: hidden;
    background-color: white;
  }
  .comUser{
    width: 100%;
    display: flex;
    margin-bottom: 15px;
  }
  .userImg{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
  }
  .userInfo{
    width: 285px;
  }
  .userInfo h6{
    font-size: 18px;
    margin-bottom: 8px;
  }
  .userInfo span{
    margin-left: 5px;
    font-size: 12px;
    color: #808080;
  }
  .userInfo .approve{
    float: right;
    margin-top: 5px;
    margin-right: 25px;
    font-size: 14px;
    padding: 0 5px;
    background-color: #b2dce7;
    border-radius: 15px;
    line-height: 25px;
    color: #008baf;
  }
  .userInfo p{
    color: #808080;

  }

  .comIntro{
    color: #808080;
    line-height: 18px;
    margin-bottom: 15px;
    text-indent: 2em;
    letter-spacing: 1px;
    line-height: 22px;
    font-size: 14px;
    color: black;
  }
  

  .place{
    color: #008baf;
    vertical-align: middle;
    height: 23px;
  }
  .place i{
    vertical-align: middle;
    font-size: 18px;
  }
  .place span{
    vertical-align: middle;
  }

  /* goodsImg */
  .goodsImg{
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    border-bottom: 1px solid #cccccc;
  }
  .goodsImg>div{
    width: 111px;
    height: 111px;
  }
  /* footer */
  .comAction{
    padding-top: 5px;
    display: flex;
    justify-content: space-between;
    color: #808080;
  }
  .comAction .action span{
    margin-right: 5px;
    vertical-align: middle;
  }
  .comAction i{
    vertical-align: middle;
  }
  .zanwu{
    width: 100%;
    height: calc(100% - 50px);
    text-align: center;
  }
  .zanwu>div{
    width: 200px;
    margin:  40px auto 20px;
  }
</style>